import React from 'react';

import { Form } from 'antd';
import { FaEnvelope } from 'react-icons/fa';

import { FormInput } from '@src/components/atoms/form/form-input';
import { TextLink } from '@src/components/atoms/text-link';
import { GradientButton } from '@src/components/molecules/gradient-button';

import { StyledForgotForm } from './styles';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('forgot-form');

const ForgotForm = ({ onForgot, onSwitchTo, loading }) => {
  const [form] = Form.useForm();

  return (
    <StyledForgotForm>
      <Form
        className={b()}
        form={form}
        layout="vertical"
        onFinish={onForgot}
        initialValues={{
          email: '',
        }}
      >
        <div className={b('item')}>
          <FormInput
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'The input is not valid E-mail!' },
            ]}
            icon={<FaEnvelope />}
            form={form}
          />
        </div>

        <div className={b('item')}>
          <TextLink onClick={() => onSwitchTo('login')}>Back to login</TextLink>
        </div>

        <div className={b('submit')}>
          <Form.Item>
            <GradientButton type={loading ? 'button' : 'submit'} loading={loading} width="auto">
              CONTINUE
            </GradientButton>
          </Form.Item>
        </div>
      </Form>
    </StyledForgotForm>
  );
};

export default ForgotForm;
